import { el, mount, unmount } from 'redom';

import ContactResultRow from './contact-result-row';
import PageResultRow from './page-result-row';

class SearchResultRow {

  constructor() {

    this.data = null;
    this.onClick = null;
    this.contentComponent = null;
    this.currentType = null;

    this.el = el('.search-result-row', [], {
      onclick: this.handleClick.bind(this)
    });

  }

  update(data, index, items, context) {

    this.data = data;
    this.onClick = context.onClick;

    const resultType = data.type;

    if (this.currentType !== resultType) {
      if (this.contentComponent !== null) {
        unmount(this.el, this.contentComponent);
      }

      const ResultComponentClass = this.getResultComponentClass(resultType);
      this.contentComponent = new ResultComponentClass();
      mount(this.el, this.contentComponent);
      this.currentType = resultType;
    }

    this.contentComponent.update(data);

  }

  getResultComponentClass(type) {

    if (type === 'CONTACT') {
      return ContactResultRow;
    }

    if (type === 'PAGE') {
      return PageResultRow;
    }

    return ContactResultRow;

  }

  handleClick(event) {

    if (this.onClick !== null) {
      this.onClick(this.data, event);
    }

  }

}

export default SearchResultRow;